export enum CheckoutStep {
  Cart = 'cart',
  Shipping = 'shipping',
  Payment = 'payment',
  ThankYou = 'thank-you',
}
